// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-approvals[data-v-0d061490] {\n  max-height: 500px;\n  overflow-y: scroll;\n}", ""]);
// Exports
module.exports = exports;
